import { Post } from '@wellesley/openapi'

const addEmojisToText = (text: string, emojis: Post['emojis']) => {
  if (!emojis?.length) return text

  const textWithEmojis = emojis.reduce((acc, item) => {
    acc = acc.replaceAll(
      new RegExp(`:${item.shortcode}:`, 'g'),
      `<img class="custom-emoji" src="${item.staticUrl}" alt='emoji ${item.shortcode}'/>`,
    )
    return acc
  }, text)

  return textWithEmojis
}

export default addEmojisToText
